/**
 * Format a phone number as the user types (auto-insert hyphens)
 * Converts "5551234567" -> "555-123-4567"
 */
export function formatPhoneInput(value: string): string {
  // Remove all non-digit characters
  const digits = value.replace(/\D/g, '')

  // Limit to 10 digits
  const limited = digits.slice(0, 10)

  // Format with hyphens as user types
  if (limited.length <= 3) {
    return limited
  } else if (limited.length <= 6) {
    return `${limited.slice(0, 3)}-${limited.slice(3)}`
  } else {
    return `${limited.slice(0, 3)}-${limited.slice(3, 6)}-${limited.slice(6)}`
  }
}

/**
 * Strip formatting from a phone number for validation
 * Converts "555-123-4567" -> "5551234567"
 */
export function stripPhoneFormatting(value: string): string {
  return value.replace(/\D/g, '')
}

/**
 * Validate US phone number format (must be exactly 10 digits)
 */
export function validateUSPhone(value: string): boolean {
  const digits = stripPhoneFormatting(value)
  return digits.length === 10 && /^\d{10}$/.test(digits)
}

/**
 * Format a stored phone number for display (already formatted in DB)
 */
export function displayPhoneNumber(value: string): string {
  // Phone numbers from backend should already be formatted as XXX-XXX-XXXX
  return value
}
